import React from 'react';
import MUIListItemButton, {
  ListItemButtonProps as MUIListItemButtonProps,
} from '@mui/material/ListItemButton';
import MUIListItemIcon, { ListItemIconProps } from '@mui/material/ListItemIcon';
import MUIListItemText, { ListItemTextProps } from '@mui/material/ListItemText';
import MUIListItemAvatar, { ListItemAvatarProps } from '@mui/material/ListItemAvatar';

export const ListItemIcon = React.forwardRef<HTMLDivElement, ListItemIconProps>(
  (props, ref) => {
    return (
      <MUIListItemIcon ref={ref} {...props}>
        {props.children}
      </MUIListItemIcon>
    );
  },
);

ListItemIcon.displayName = 'ListItemIcon';

export const ListItemText = React.forwardRef<HTMLDivElement, ListItemTextProps>(
  (props, ref) => {
    return (
      <MUIListItemText ref={ref} {...props}>
        {props.children}
      </MUIListItemText>
    );
  },
);

ListItemText.displayName = 'ListItemText';

export const ListItemAvatar = React.forwardRef<HTMLDivElement, ListItemAvatarProps>(
  (props, ref) => {
    return (
      <MUIListItemAvatar ref={ref} {...props}>
        {props.children}
      </MUIListItemAvatar>
    );
  },
);

ListItemAvatar.displayName = 'ListItemAvatar';

export type ListItemButtonProps = MUIListItemButtonProps;

const ListItemButton = React.forwardRef<HTMLDivElement, ListItemButtonProps>((props, ref) => {
  return (
    <MUIListItemButton ref={ref} {...props}>
      {props.children}
    </MUIListItemButton>
  );
});

ListItemButton.displayName = 'ListItemButton';

export default ListItemButton;
